import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import mainBg from "../assets/images/mainBg.jpg";
import jokerBg from "../assets/images/Joker Salon for Men.jpeg";
import quinnBg from "../assets/images/Quinn Salon for Women.jpeg";

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      image: mainBg,
      alt: "Joker & Quinn Salon",
      title: (
        <>
          WELCOME TO<br />
          <span className="font-bold not-italic">JOKER & QUINN</span>
        </>
      ),
      subtitle: "Unisex Luxury Salon"
    },
    {
      image: jokerBg,
      alt: "Joker Salon for Men",
      title: (
        <>
          <span className="font-bold not-italic">JOKER SALON</span>
        </>
      ),
      subtitle: "Luxury Salon for Men"
    },
    {
      image: quinnBg,
      alt: "Quinn Salon for Women",
      title: (
        <>
          <span className="font-bold not-italic">QUINN SALON</span>
        </>
      ),
      subtitle: "Luxury Salon for Women"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden pt-20">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.alt}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-white/70 to-transparent"></div>
        </div>
      ))}

      {/* Content */}
      <div className="relative h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-2xl">
            <h2 className="text-5xl md:text-7xl font-serif italic text-gray-900 mb-2 leading-tight">
              {slides[currentSlide].title}
            </h2>
            {slides[currentSlide].subtitle && (
              <p className="italic tracking-wider mb-8" style={{ fontFamily: 'Times New Roman', fontSize: '36px', color: '#9B111E', fontWeight: 'bold', textShadow: '2px 2px 4px white' }}>
                {slides[currentSlide].subtitle}
              </p>
            )}
            <Button
              size="lg"
              className="bg-black hover:bg-gray-800 text-white px-8 py-6 text-lg rounded-full transition-all duration-300 transform hover:scale-105"
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
            >
              EXPLORE
            </Button>
          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all ${
              index === currentSlide ? 'bg-gray-900 w-8' : 'bg-gray-400'
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
